import HttpService from './HttpService';
import * as supplierAction from '../actions/supplierAction';
import { getUrlSupplierApi, showMessageToastCustom, translate } from '../utils/util';

const httpService = new HttpService(getUrlSupplierApi(window));

export default class SupplierService {
    static getSuppliers(text, plantId, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                let systemID = 10;
                var parameters = `text=${text}&plantId=${plantId}&systemID=${systemID}&rowsPerPage=45`
                httpService.instance.get(`/api/supplier/searchSupplierIsJit?${parameters}`, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') })
                    .then((response) => {
                        if (response.status === 200 && response.data?.items) {
                            dispatch(supplierAction.setSupplierList(response.data?.items));
                            if (callback) {
                                callback(response.data?.items);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                        if (callback) {
                            callback();
                        }
                    })
            };
        }
    }
}